<script setup lang="ts">
import feather, { FeatherIconNames } from "feather-icons";
import { computed, SVGAttributes } from "vue";

const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: "24",
    validator: (s: string) =>
      !Number.isNaN(s) ||
      (s.length >= 2 &&
        !Number.isNaN(s.slice(0, s.length - 1)) &&
        s.slice(-1) === "x")
  }
});

const size = computed(() =>
  props.size.slice(-1) === "x"
    ? props.size.slice(0, props.size.length - 1) + "em"
    : `${parseInt(props.size, 10)}px`
);

const icon = computed(() => feather.icons[props.icon as FeatherIconNames]);

const svgAttrs = computed(() => {
  const attrs = {
    ...icon.value.attrs,
    width: size.value,
    height: size.value
  };
  return attrs as SVGAttributes;
});

const html = computed(() => icon.value.contents);

const emits = defineEmits(["click"]);
</script>

<template>
  <svg
    v-if="icon"
    v-bind="svgAttrs"
    v-html="html"
    @click="emits('click')"
  ></svg>
</template>
